import axios from "axios";
import { handleError } from "../Components/Helpers/ErrorHandler";
import { PortfolioGet, PortfolioPost } from "../Models/Portfolio";

const api = process.env.REACT_APP_API_URL || "http://localhost:8080/api/";

const getToken = () => {
  return localStorage.getItem("token") || sessionStorage.getItem("token");
};

export const addPortfolioAPI = async (symbol: string) => {
  try {
    const data = await axios.post<PortfolioPost>(api + "portfolio/" + `?symbol=${symbol}`, null, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    });
    return data;
  } catch (error) {
    handleError(error);
  }
};

export const deletePortfolioAPI = async (symbol: string) => {
  try {
    const data = await axios.delete<PortfolioPost>(api + "portfolio/" + `?symbol=${symbol}`, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    });
    return data;
  } catch (error) {
    handleError(error);
  }
};

export const getPortfolioAPI = async () => {
  try {
    const data = await axios.get<PortfolioGet[]>(api + "portfolio/", {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    });
    return data;
  } catch (error) {
    handleError(error);
  }
};
